export default __webpack_public_path__ + "static/media/tagsnpeoplegrey.01b1aad6.svg";